module.exports = __webpack_public_path__ + "static/media/telephone-white.6e5c5a43.svg";